var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-select",
    _vm._b(
      {
        attrs: {
          clearable: true,
          align: _vm.column.align,
          "hide-underline": true,
          placeholder: "All"
        },
        on: { input: _vm.applyFilter, clear: _vm.applyFilter },
        model: {
          value: _vm.localValue,
          callback: function($$v) {
            _vm.localValue = $$v
          },
          expression: "localValue"
        }
      },
      "q-select",
      _vm.column.component ? _vm.column.component.props : {},
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }